module.exports = __webpack_public_path__ + "img/bg-dark.ebc16c0f.png";